import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserQuestionnaire } from "../../../../models/check-interface";
import { CheckStorageService } from '../../../../services/check-storage.service';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'lib-notes-tab',
  templateUrl: './notes-tab.component.html',
  styleUrls: ['./notes-tab.component.scss']
})
export class NotesTabComponent implements AfterViewInit {

  @Input() userQuestionnaire!: UserQuestionnaire;
  @Output() emitClickTextarea: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('notes') notesTextArea!: ElementRef;
  @Input() editable!: boolean;

  constructor(
    private checkStorageService: CheckStorageService,
    private config: AppConfig
  ){}

  ngAfterViewInit(): void {
    this.notesTextArea.nativeElement.value = this.userQuestionnaire.comment;
    const lines = this.notesTextArea.nativeElement.value.split('\n').length;
    this.notesTextArea.nativeElement.style.height = (lines * 26) + 'px';
    this.notesTextArea.nativeElement.disabled = !this.editable;

    setTimeout(() => {
      this.notesTextArea.nativeElement.focus();
      this.clickTextarea();
      setTimeout(() => {
        this.onChangeNotes();
      }, 100);
    }, 100);
  }

  onFocusOutTextareaEvent(event: any) {
    const value = event.target.value;
    this.userQuestionnaire.comment = value;
    this.emitClickTextarea.emit(false);
    this.checkStorageService.putNotesUserQuestionnaires(this.userQuestionnaire.id, this.userQuestionnaire).subscribe((resp: any) => {
      this.checkStorageService.putCheckUpdatedBy(this.config.checkId, this.config.userData.userId);
      this.userQuestionnaire.comment = resp.comment;
    });
  }

  onChangeNotes() {
    var currentHeight = parseInt(this.notesTextArea.nativeElement.style.height.replace('px', ''));
    if (currentHeight >= 330) {
      this.notesTextArea.nativeElement.style.overflowY = 'scroll';
    } else {
      this.notesTextArea.nativeElement.style.overflowY = 'hidden';
    }
  }

  onShowNotesClick() {
    if(!this.editable) return;
    this.userQuestionnaire.showNotes = !this.userQuestionnaire.showNotes;
    this.checkStorageService.putShowNotesQuestionnaire(this.userQuestionnaire.id, this.userQuestionnaire).subscribe((resp: any) => {
      this.checkStorageService.putCheckUpdatedBy(this.config.checkId, this.config.userData.userId);
      this.userQuestionnaire.showNotes = resp.showNotes;
    });
  }

  clickTextarea() {
    this.emitClickTextarea.emit(true);
  }
}
